import { makeAutoObservable } from 'mobx';
import admin from '../api/admin';
import { RootStore } from './rootStore';
import { AxiosError } from 'axios';
import { useToast } from '@chakra-ui/react';
import { GetSharedProjectViewResponse } from '../models/admin-api/dto';
import { IHotspot } from '../models/hotspot';

export class ExternalViewerStore {
  viewData: string = '';
  isLoading: boolean = false;
  root: RootStore;
  showPasswordDialog = false;
  selectedAssetId : string = undefined;
  showViewerDialog = false;
  toast = useToast();
  currentHotspot: IHotspot | undefined;
  pwd :string = undefined;
  
  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this);
    window['VTExternalStore'] = this;
  }
  

    //Global Show Hotspot Page in Builder
    setShowViewerDialog(show: boolean) {
      this.showViewerDialog = show;
    }

       //Global Show Hotspot Page in Builder
    setPassword(password: string) {
        this.pwd = password;
      }

  getAssetRepairDetails(assetid: string) {
    this.selectedAssetId = assetid;
    this.setShowViewerDialog(true);
    return true;
  }

  getExternalViewingData = async (id: string, password?: string) => {
    this.isLoading = true;
    admin.SharedProjects.GetViewData(id, password)
      .then((response: GetSharedProjectViewResponse) => {
        if (response) {
          if (response.result !== '' && response.result !== undefined) {
            this.viewData = response?.result!;
            this.setShowPasswordDialog(false);
          } 
        }
      })
      .catch((error: AxiosError) => {
        console.log(error);

        if (error?.response?.data! !== undefined) {
      

          if (
            error?.response?.data['message'] ==
            'The shared project password is incorrect.'
          ) {
  

            this.setShowPasswordDialog(true);

          } else {
            this.toast({
              title: 'Error accessing Theia360 Shared Project!',
              description:
                'Please ensure the shared project is enabled and the URL is corrrect',
              status: 'error',
              duration: 4000,
              isClosable: true,
            });
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  };

  //Global Show Hotspot Page in Builder
  setShowPasswordDialog(show: boolean) {
    this.showPasswordDialog = show;
  }

  clearPasswordDialog() {
    this.setShowPasswordDialog(false);
  }

  clearDialogs() {
    this.setShowViewerDialog(false);
  }
}
